import utils from '@/utils/utils.js';

var dns = "https://" + window.location.hostname;
var basePathFiles = utils.isParentApp() ? '/parent/' : "/reader/";
var basePath = utils.isParentApp() ? '/parent' : "/reader";
var localServer = false;

if(window.location.hostname === "reader.app.dev.it.si") {
  dns = "https://app.dev.it.si";
  // basePathFiles = "/";
  // basePath = "";
  localServer = true;
}

export default {
  dns: dns,
  pdfTronKey: 'ITSI Holdings(it.si):OEM:miEbooks Web Reader::B+:AMS(20220201):CEB5AF220487260A7360B13AC9A2537860610FB5D7C3369A8B12F4C2442C930D06D6BEF5C7',
  basePath,
  basePathFiles,
  ecApi: dns + "/educator/api/1.0/",
  localServer,
  localServerOrAppDev: localServer || window.location.hostname === "app.dev.it.si",
  errorMessageClearedAfter: 30,
  pdfPerPage: 100
}
